import { SET_CURRENT_USER, RESET_AUTH, SET_CONSTANTS, SET_TENANT } from '../actions/types';
import isEmpty from '../is-empty';
import common from '../jsons/common.json';

const initialState = {
    isAuthenticated: false,
    user: {},
    isInternalAdmin: false,
    isImpersonating: false,
    constants: { objectIds: {} },
    screenDefs: {},
}

export default function authReducer(state = initialState, action){
    switch(action.type){
        case SET_CURRENT_USER:
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: {
                    ...state.user,
                    ...action.payload.user,
                    // Preserve theme from persisted state (not JWT)
                    theme: state.user.theme ?? action.payload.user?.theme
                },
                referralLink: action.payload.referralLink,
                isInternalAdmin: action.payload.user && action.payload.user.internal && !action.payload.user.tenant,
                isImpersonating: !!(action.payload.user && action.payload.user.impersonating)
            }
        case SET_CONSTANTS: 
            return {
                ...state, 
                common: common,
                constants: action.payload.constants,
                screenDefs: action.payload.screenDefs
            }
        case SET_TENANT:
            return {
                ...state,
                user: { ...state.user, tenant: action.payload.tenant, tenantSel: action.payload.tenantSel },
                constants: action.payload.constants
            }
        case RESET_AUTH:
            return initialState;
        case 'UPDATE_USER_THEME':
            return {
                ...state,
                user: { ...state.user, theme: action.payload }
            };
        case 'UPDATE_USER_ADD_MY_USER':
            return {
                ...state,
                user: { ...state.user, addMyUser: action.payload }
            };
        default:
            return state;
    }
}